import onScan from "onscan.js";


// Enable scan events for the entire document
onScan.attachTo(document,{
    // ignoreIfFocusOn: 'input',
    // stopPropagation: true,
    // preventDefault: true,
    // reactToPaste: true, // Compatibility to built-in scanners in paste-mode (as opposed to keyboard-mode)
    
    onScan: function(sCode, iQty) { // Alternative to document.addEventListener('scan')
        console.log('Scanned: ' + iQty + 'x ' + sCode); 
    },
    onKeyDetect: function(iKeyCode){ // output all potentially relevant key events - great for debugging!
        console.log('Pressed: ' + iKeyCode);
    }
});

// // Register event listener
// document.addEventListener('scan', function(scanEvent) {
//     scanEvent.stopPropagation();
//     scanEvent.stopImmediatePropagation();
//     scanEvent.preventDefault();
//     console.log(scanEvent); 
//     console.log(scanEvent.detail.scanCode);


// });